import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';

import { BudgetService } from '../service/budget.service';
import { CompanyService } from '../service/company.service';
import { HomeService } from '../service/home.service';
import { LoanService } from '../service/loan.service';
import { OperatingexpensesService } from '../service/operatingexpenses.service';
import { OtherService } from '../service/other.service';
import { ProjectService } from '../service/project.service';

@Component({
  selector: 'app-recast',
  templateUrl: './recast.component.html',
  styleUrls: ['./recast.component.css'],
})
export default class RecastComponent implements OnInit {
  constructor(
    private operatingService: OperatingexpensesService,
    private otherService: OtherService,
    private homeService: HomeService,
    private loanService: LoanService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private budgetService: BudgetService,
    private route: ActivatedRoute,
    private router: Router,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    public fb: FormBuilder
  ) {
    this.toastr.setRootViewContainerRef(vRef);
    this.showInstructions = false;
    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    this.getOtherFields();
    this.getProjectData();
    this.getCompanyData();
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Output() recastEmit: EventEmitter<any> = new EventEmitter();

  @Output() otherEmitRecast: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES
  projectId: string;

  companyId: string;

  projectName: string;

  companyLogoUrl = '';

  alphabets: any = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];

  // seller recast variables
  id: string;

  year = 1;

  start_up_month = 0;

  otherPayrollExpensesArray = [];

  otherGeneralExpensesArray = [];

  otherOperExpensesArray = [];

  otherPayrollSum = [];

  otherGeneralSum = [];

  otherMiscSum = [];

  recastMonths = 12;

  recastMonthsInt = 0;

  recastOccupiedBeds = 0;

  recastGOI = 0;

  recastGOIInt = 0;

  recastManagementFee = 0;

  recastManagementFeeInt = 0;

  recastManagerSalary = 0;

  recastManagerSalaryInt = 0;

  recastManagerBonus = 0;

  recastManagerBonusInt = 0;

  recastCompFactor = 0;

  recastCompFactorInt = 0;

  recastCaregiversWages = 0;

  recastCaregiversWagesInt = 0;

  recastChef = 0;

  recastChefInt = 0;

  recastCleaningStaff = 0;

  recastCleaningStaffInt = 0;

  recastRent = 0;

  recastRentInt = 0;

  recastTaxes = 0;

  recastTaxesInt = 0;

  recastInsuranceProperty = 0;

  recastInsurancePropertyInt = 0;

  recastGas = 0;

  recastGasInt = 0;

  recastWater = 0;

  recastWaterInt = 0;

  recastElectric = 0;

  recastElectricInt = 0;

  recastGarbageRemoval = 0;

  recastGarbageRemovalInt = 0;

  recastLandscaping = 0;

  recastLandscapingInt = 0;

  recastExtermininator = 0;

  recastExtermininatorInt = 0;

  recastBusinessLicense = 0;

  recastBusinessLicenseInt = 0;

  recastAccountingServices = 0;

  recastAccountingServicesInt = 0;

  recastHOFFees = 0;

  recastHOFFeesInt = 0;

  recastFood = 0;

  recastFoodInt = 0;

  recastHousekeeping = 0;

  recastHousekeepingInt = 0;

  recastOfficeSupplies = 0;

  recastOfficeSuppliesInt = 0;

  recastSecurityMonitoring = 0;

  recastSecurityMonitoringInt = 0;

  recastRecreationalActivites = 0;

  recastRecreationalActivitesInt = 0;

  recastWebsite = 0;

  recastWebsiteInt = 0;

  recastReferralFeesStartup = 0;

  recastReferralFeesStartupInt = 0;

  recastReferralFeesOngoing = 0;

  recastReferralFeesOngoingInt = 0;

  recastInsuranceLiability = 0;

  recastInsuranceLiabilityInt = 0;

  recastCable = 0;

  recastCableInt = 0;

  recastRepairs = 0;

  recastRepairsInt = 0;

  recastTransportion = 0;

  recastTransportionInt = 0;

  recastFurnitureLease = 0;

  recastFurnitureLeaseInt = 0;

  recastMembershipFees = 0;

  recastMembershipFeesInt = 0;

  // seller recast monthly variables
  monthlyRecastOccupiedBeds = 0;

  monthlyRecastGOI = 0;

  monthlyRecastManagementFee = 0;

  monthlyRecastManagerSalary = 0;

  monthlyRecastManagerBonus = 0;

  monthlyRecastCompFactor = 0;

  monthlyRecastCaregiversWages = 0;

  monthlyRecastChef = 0;

  monthlyRecastCleaningStaff = 0;

  monthlyRecastRent = 0;

  monthlyRecastTaxes = 0;

  monthlyRecastInsuranceProperty = 0;

  monthlyRecastGas = 0;

  monthlyRecastWater = 0;

  monthlyRecastElectric = 0;

  monthlyRecastGarbageRemoval = 0;

  monthlyRecastLandscaping = 0;

  monthlyRecastExtermininator = 0;

  monthlyRecastBusinessLicense = 0;

  monthlyRecastAccountingServices = 0;

  monthlyRecastHOFFees = 0;

  monthlyRecastFood = 0;

  monthlyRecastHousekeeping = 0;

  monthlyRecastOfficeSupplies = 0;

  monthlyRecastSecurityMonitoring = 0;

  monthlyRecastRecreationalActivites = 0;

  monthlyRecastWebsite = 0;

  monthlyRecastReferralFeesStartup = 0;

  monthlyRecastReferralFeesOngoing = 0;

  monthlyRecastInsuranceLiability = 0;

  monthlyRecastCable = 0;

  monthlyRecastRepairs = 0;

  monthlyRecastTransportion = 0;

  monthlyRecastFurnitureLease = 0;

  monthlyRecastMembershipFees = 0;

  recastPayrollTotalPayroll = 0;

  recastPayrollTotalGOI = 0;

  monthlyRecastPayrollTotalPayroll = 0;

  monthlyRecastPayrollTotalGOI = 0;

  recastGeneralTotalPayroll = 0;

  recastGeneralTotalGOI = 0;

  monthlyRecastGeneralTotalPayroll = 0;

  monthlyRecastGeneralTotalGOI = 0;

  recastOperatingPayroll = 0;

  recastOperatingGOI = 0;

  monthlyRecastOperatingPayroll = 0;

  monthlyRecastOperatingGOI = 0;

  // buyer's annual variables
  occupied_beds;

  gross_operating_income = 0;

  management_fee = 0;

  manager_salary = 0;

  manager_bonus = 0;

  workers_comp_factor = 0;

  caregivers_wages = 0;

  chef = 0;

  cleaning_staff = 0;

  rent = 0;

  taxes = 0;

  insurance_property = 0;

  gas = 0;

  water_sewer = 0;

  electric = 0;

  garbage_removal = 0;

  landscaping_plowing = 0;

  exterminator = 0;

  business_license_renewal = 0;

  accounting_payroll_services = 0;

  hoa_fees = 0;

  food = 0;

  housekeeping_supplies = 0;

  office_supplies = 0;

  security_monitoring = 0;

  recreational_activities = 0;

  website_advertising = 0;

  referral_fees_start_up = 0;

  referral_fees_ongoing = 0;

  insurance_liability = 0;

  cable = 0;

  repairs_maintenance = 0;

  transportation = 0;

  furniture_lease = 0;

  membership_fees = 0;

  // monthly buyers variables
  monthly_occupied_beds = 0;

  monthly_gross_operating_income = 0;

  monthly_management_fee = 0;

  monthly_manager_salary = 0;

  monthly_manager_bonus = 0;

  monthly_workers_comp_factor = 0;

  monthly_caregivers_wages = 0;

  monthly_chef = 0;

  monthly_cleaning_staff = 0;

  monthly_rent = 0;

  monthly_taxes = 0;

  monthly_insurance_property = 0;

  monthly_gas = 0;

  monthly_water_sewer = 0;

  monthly_electric = 0;

  monthly_garbage_removal = 0;

  monthly_landscaping_plowing = 0;

  monthly_exterminator = 0;

  monthly_business_license_renewal = 0;

  monthly_accounting_payroll_services = 0;

  monthly_hoa_fees = 0;

  monthly_food = 0;

  monthly_housekeeping_supplies = 0;

  monthly_office_supplies = 0;

  monthly_security_monitoring = 0;

  monthly_recreational_activities = 0;

  monthly_website_advertising = 0;

  monthly_referral_fees_start_up = 0;

  monthly_referral_fees_ongoing = 0;

  monthly_insurance_liability = 0;

  monthly_cable = 0;

  monthly_repairs_maintenance = 0;

  monthly_transportation = 0;

  monthly_furniture_lease = 0;

  monthly_membership_fees = 0;

  // total variables
  total_payroll = 0;

  total_payroll_goi = 0;

  total_monthly_payroll = 0;

  total_monthly_payroll_goi = 0;

  total_general_expenses = 0;

  total_general_expenses_goi = 0;

  total_monthly_general_expenses = 0;

  total_monthly_general_expenses_goi = 0;

  total_operating_expenses = 0;

  total_operating_expenses_goi = 0;

  total_monthly_operating_expenses = 0;

  total_monthly_operating_expenses_goi = 0;

  // comparison variables

  // buyer's annual variables
  comp_occupied_beds = 0;

  comp_gross_operating_income = 0;

  comp_management_fee = 0;

  comp_manager_salary = 0;

  comp_manager_bonus = 0;

  comp_workers_comp_factor = 0;

  comp_caregivers_wages = 0;

  comp_chef = 0;

  comp_cleaning_staff = 0;

  comp_rent = 0;

  comp_taxes = 0;

  comp_insurance_property = 0;

  comp_gas = 0;

  comp_water_sewer = 0;

  comp_electric = 0;

  comp_garbage_removal = 0;

  comp_landscaping_plowing = 0;

  comp_exterminator = 0;

  comp_business_license_renewal = 0;

  comp_accounting_payroll_services = 0;

  comp_hoa_fees = 0;

  comp_food = 0;

  comp_housekeeping_supplies = 0;

  comp_office_supplies = 0;

  comp_security_monitoring = 0;

  comp_recreational_activities = 0;

  comp_website_advertising = 0;

  comp_referral_fees_start_up = 0;

  comp_referral_fees_ongoing = 0;

  comp_insurance_liability = 0;

  comp_cable = 0;

  comp_repairs_maintenance = 0;

  comp_transportation = 0;

  comp_furniture_lease = 0;

  comp_membership_fees = 0;

  // monthly buyers variables
  comp_monthly_occupied_beds = 0;

  comp_monthly_gross_operating_income = 0;

  comp_monthly_management_fee = 0;

  comp_monthly_manager_salary = 0;

  comp_monthly_manager_bonus = 0;

  comp_monthly_workers_comp_factor = 0;

  comp_monthly_caregivers_wages = 0;

  comp_monthly_chef = 0;

  comp_monthly_cleaning_staff = 0;

  comp_monthly_rent = 0;

  comp_monthly_taxes = 0;

  comp_monthly_insurance_property = 0;

  comp_monthly_gas = 0;

  comp_monthly_water_sewer = 0;

  comp_monthly_electric = 0;

  comp_monthly_garbage_removal = 0;

  comp_monthly_landscaping_plowing = 0;

  comp_monthly_exterminator = 0;

  comp_monthly_business_license_renewal = 0;

  comp_monthly_accounting_payroll_services = 0;

  comp_monthly_hoa_fees = 0;

  comp_monthly_food = 0;

  comp_monthly_housekeeping_supplies = 0;

  comp_monthly_office_supplies = 0;

  comp_monthly_security_monitoring = 0;

  comp_monthly_recreational_activities = 0;

  comp_monthly_website_advertising = 0;

  comp_monthly_referral_fees_start_up = 0;

  comp_monthly_referral_fees_ongoing = 0;

  comp_monthly_insurance_liability = 0;

  comp_monthly_cable = 0;

  comp_monthly_repairs_maintenance = 0;

  comp_monthly_transportation = 0;

  comp_monthly_furniture_lease = 0;

  comp_monthly_membership_fees = 0;

  // COMPARISON VALUES TOTAL VARIABLES
  comp_payroll = 0;

  comp_monthly_payroll = 0;

  comp_general_expenses = 0;

  comp_monthly_general_expenses = 0;

  comp_operating_expenses = 0;

  comp_monthly_operating_expenses = 0;

  showInstructions: boolean;

  ngOnInit() {
    this.getOperatingData();
    // To focus onto first input field when come to this page as long as the element exists. (It doesn't exist when printing.)
    if (document.getElementById('recast_months')) {
      setTimeout(() => {
        document.getElementById('recast_months').focus();
      }, 1500);
    }
  }

  // TO GET PROJECT NAME FROM PROJECT SERVICE FROM DB
  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.start_up_month = projectData.data[0].start_up_month;
    });
  }

  // GET SAVED COMPANY LOGO FROM DB
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }

  // TO GET SAVED OPEX PAGE'S DATA BUYER'S & SELLER'S RECAST DATA
  async getOperatingData() {
    this.operatingService.getRecords(this.projectId, this.year).subscribe(async (data) => {
      if (data.messageId === 200) {
        this.id = data.data[0]._id;

        // GET SELLER'S RECAST DATA
        this.recastMonths = data.data[0].seller_months;
        this.recastMonthsInt = data.data[0].seller_months;

        this.recastOccupiedBeds = data.data[0].seller_occupied_beds;
        this.recastGOI = data.data[0].seller_gross_operating_income;
        this.recastGOIInt = data.data[0].seller_gross_operating_income;

        this.recastManagementFee = data.data[0].seller_management_fee;
        this.recastManagementFeeInt = data.data[0].seller_management_fee;

        this.recastManagerSalary = data.data[0].seller_manager_salary;
        this.recastManagerSalaryInt = data.data[0].seller_manager_salary;

        this.recastManagerBonus = data.data[0].seller_manager_bonus;
        this.recastManagerBonusInt = data.data[0].seller_manager_bonus;

        this.recastCompFactor = data.data[0].seller_workers_comp_factor;
        this.recastCompFactorInt = data.data[0].seller_workers_comp_factor;

        this.recastCaregiversWages = data.data[0].seller_caregivers_wages;
        this.recastCaregiversWagesInt = data.data[0].seller_caregivers_wages;

        this.recastChef = data.data[0].seller_chef;
        this.recastChefInt = data.data[0].seller_chef;

        this.recastCleaningStaff = data.data[0].seller_cleaning_staff;
        this.recastCleaningStaffInt = data.data[0].seller_cleaning_staff;

        this.recastRent = data.data[0].seller_rent;
        this.recastRentInt = data.data[0].seller_rent;

        this.recastTaxes = data.data[0].seller_taxes;
        this.recastTaxesInt = data.data[0].seller_taxes;

        this.recastInsuranceProperty = data.data[0].seller_insurance_property;
        this.recastInsurancePropertyInt = data.data[0].seller_insurance_property;

        this.recastGas = data.data[0].seller_gas;
        this.recastGasInt = data.data[0].seller_gas;

        this.recastWater = data.data[0].seller_water_sewer;
        this.recastWaterInt = data.data[0].seller_water_sewer;

        this.recastElectric = data.data[0].seller_electric;
        this.recastElectricInt = data.data[0].seller_electric;

        this.recastGarbageRemoval = data.data[0].seller_garbage_removal;
        this.recastGarbageRemovalInt = data.data[0].seller_garbage_removal;

        this.recastLandscaping = data.data[0].seller_landscaping_plowing;
        this.recastLandscapingInt = data.data[0].seller_landscaping_plowing;

        this.recastExtermininator = data.data[0].seller_exterminator;
        this.recastExtermininatorInt = data.data[0].seller_exterminator;

        this.recastBusinessLicense = data.data[0].seller_business_license_renewal;
        this.recastBusinessLicenseInt = data.data[0].seller_business_license_renewal;

        this.recastAccountingServices = data.data[0].seller_accounting_payroll_services;
        this.recastAccountingServicesInt = data.data[0].seller_accounting_payroll_services;

        this.recastHOFFees = data.data[0].seller_hoa_fees;
        this.recastHOFFeesInt = data.data[0].seller_hoa_fees;

        this.recastFood = data.data[0].seller_food;
        this.recastFoodInt = data.data[0].seller_food;

        this.recastHousekeeping = data.data[0].seller_housekeeping_supplies;
        this.recastHousekeepingInt = data.data[0].seller_housekeeping_supplies;

        this.recastOfficeSupplies = data.data[0].seller_office_supplies;
        this.recastOfficeSuppliesInt = data.data[0].seller_office_supplies;

        this.recastSecurityMonitoring = data.data[0].seller_security_monitoring;
        this.recastSecurityMonitoringInt = data.data[0].seller_security_monitoring;

        this.recastRecreationalActivites = data.data[0].seller_recreational_activities;
        this.recastRecreationalActivitesInt = data.data[0].seller_recreational_activities;

        this.recastWebsite = data.data[0].seller_website_advertising;
        this.recastWebsiteInt = data.data[0].seller_website_advertising;

        this.recastReferralFeesStartup = data.data[0].seller_referral_fees_start_up;
        this.recastReferralFeesStartupInt = data.data[0].seller_referral_fees_start_up;

        this.recastReferralFeesOngoing = data.data[0].seller_referral_fees_ongoing;
        this.recastReferralFeesOngoingInt = data.data[0].seller_referral_fees_ongoing;

        this.recastInsuranceLiability = data.data[0].seller_insurance_liability;
        this.recastInsuranceLiabilityInt = data.data[0].seller_insurance_liability;

        this.recastCable = data.data[0].seller_cable_internet_phone_newspapers;
        this.recastCableInt = data.data[0].seller_cable_internet_phone_newspapers;

        this.recastRepairs = data.data[0].seller_repairs_maintenance;
        this.recastRepairsInt = data.data[0].seller_repairs_maintenance;

        this.recastTransportion = data.data[0].seller_transportation;
        this.recastTransportionInt = data.data[0].seller_transportation;

        this.recastFurnitureLease = data.data[0].seller_furniture_lease;
        this.recastFurnitureLeaseInt = data.data[0].seller_furniture_lease;

        this.recastMembershipFees = data.data[0].seller_membership_fees;
        this.recastMembershipFeesInt = data.data[0].seller_membership_fees;

        // GET BUYER'S DATA
        this.gross_operating_income = data.data[0].total_goi;
        this.management_fee = data.data[0].total_management_fee;
        this.manager_salary = data.data[0].total_manager_salary;
        this.manager_bonus = data.data[0].total_manager_salary_percent_goi;
        this.workers_comp_factor = data.data[0].workers_comp_factor;
        this.caregivers_wages = data.data[0].total_caregiver_wages;
        this.chef = data.data[0].total_chef;
        this.cleaning_staff = data.data[0].total_cleaning_staff;

        this.rent = data.data[0].total_rent;
        this.taxes = data.data[0].total_taxes;
        this.insurance_property = data.data[0].total_insurance_property;
        this.gas = data.data[0].total_gas;
        this.water_sewer = data.data[0].total_water_sewer;
        this.electric = data.data[0].total_electric;
        this.garbage_removal = data.data[0].total_garbage_removal;
        this.landscaping_plowing = data.data[0].total_landscaping_plowing;
        this.exterminator = data.data[0].total_exterminator;
        this.business_license_renewal = data.data[0].total_business_license_renewal;
        this.accounting_payroll_services = data.data[0].total_accounting_payroll_services;
        this.hoa_fees = data.data[0].total_hoa_fees;
        this.food = data.data[0].total_food;
        this.housekeeping_supplies = data.data[0].total_housekeeping_supplies;
        this.office_supplies = data.data[0].total_office_supplies;
        this.security_monitoring = data.data[0].total_security_monitoring;
        this.recreational_activities = data.data[0].total_recreational_activities;
        this.website_advertising = data.data[0].total_website_advertising;
        this.referral_fees_start_up = data.data[0].total_referral_fees_start_up;
        this.referral_fees_ongoing = data.data[0].total_referral_fees_ongoing;
        this.insurance_liability = data.data[0].total_insurance_liability;
        this.cable = data.data[0].total_cable_internet_phone_newspapers;
        this.repairs_maintenance = data.data[0].total_repairs_maintenance;
        this.transportation = data.data[0].total_transportation;
        this.furniture_lease = data.data[0].total_furniture_lease;
        this.membership_fees = data.data[0].total_membership_fees;

        // GET MONTHLY BUYER'S DATA
        this.monthly_gross_operating_income = this.gross_operating_income / 12;
        this.monthly_management_fee = data.data[0].average_management_fee;
        this.monthly_manager_salary = data.data[0].average_manager_salary;
        this.monthly_manager_bonus = data.data[0].average_manager_salary_percent_goi;
        this.monthly_workers_comp_factor = data.data[0].workers_comp_factor;
        this.monthly_caregivers_wages = Math.round(data.data[0].total_caregiver_wages / 12);
        this.monthly_chef = data.data[0].average_chef;
        this.monthly_cleaning_staff = data.data[0].average_cleaning_staff;
        this.monthly_rent = data.data[0].average_rent;
        this.monthly_taxes = data.data[0].average_taxes;
        this.monthly_insurance_property = data.data[0].average_insurance_property;
        this.monthly_gas = data.data[0].average_gas;
        this.monthly_water_sewer = data.data[0].average_water_sewer;
        this.monthly_electric = data.data[0].average_electric;
        this.monthly_garbage_removal = data.data[0].average_garbage_removal;
        this.monthly_landscaping_plowing = data.data[0].average_landscaping_plowing;
        this.monthly_exterminator = data.data[0].average_exterminator;
        this.monthly_business_license_renewal = data.data[0].average_business_license_renewal;
        this.monthly_accounting_payroll_services = data.data[0].average_accounting_payroll_services;
        this.monthly_hoa_fees = data.data[0].average_hoa_fees;
        this.monthly_food = data.data[0].average_food;
        this.monthly_housekeeping_supplies = data.data[0].average_housekeeping_supplies;
        this.monthly_office_supplies = data.data[0].average_office_supplies;
        this.monthly_security_monitoring = data.data[0].average_security_monitoring;
        this.monthly_recreational_activities = data.data[0].average_recreational_activities;
        this.monthly_website_advertising = data.data[0].average_website_advertising;
        this.monthly_referral_fees_start_up = data.data[0].average_referral_fees_start_up;
        this.monthly_referral_fees_ongoing = data.data[0].average_referral_fees_ongoing;
        this.monthly_insurance_liability = data.data[0].average_insurance_liability;
        this.monthly_cable = data.data[0].average_cable_internet_phone_newspapers;
        this.monthly_repairs_maintenance = data.data[0].average_repairs_maintenance;
        this.monthly_transportation = data.data[0].average_transportation;
        this.monthly_furniture_lease = data.data[0].average_furniture_lease;
        this.monthly_membership_fees = data.data[0].average_membership_fees;

        // #########BUYER'S PROJECTED TOTALS########//

        // await this.getOtherFields();
        // PAYROLL EXPENSES ANNUAL AND MONTHLY TOTAL AND GOI
        let otherPayrollSum = 0;
        for (let i = 0; i < this.otherPayrollExpensesArray.length; i++) {
          this.otherPayrollSum[i] = this.otherPayrollExpensesArray[i].total_other_payroll;
          otherPayrollSum += +this.otherPayrollSum[i];
        }
        let otherGeneralSum = 0;
        for (let i = 0; i < this.otherGeneralExpensesArray.length; i++) {
          this.otherGeneralSum[i] = this.otherGeneralExpensesArray[i].total_other_general;
          otherGeneralSum += +this.otherGeneralSum[i];
        }
        let otherMiscSum = 0;
        for (let i = 0; i < this.otherOperExpensesArray.length; i++) {
          this.otherMiscSum[i] = this.otherOperExpensesArray[i].total_other_opex;
          otherMiscSum += +this.otherMiscSum[i];
        }
        this.total_payroll =
          this.management_fee +
          this.manager_salary +
          this.manager_bonus +
          this.caregivers_wages +
          this.chef +
          this.cleaning_staff +
          otherPayrollSum;

        this.total_payroll_goi = data.data[0].total_payroll_year_goi;
        this.total_monthly_payroll = this.total_payroll / 12;
        this.total_monthly_payroll_goi = this.total_payroll_goi;

        // GENERAL EXPENSES ANNUAL AND MONTHLY TOTAL AND GOI
        this.total_general_expenses =
          this.rent +
          this.taxes +
          this.insurance_property +
          this.gas +
          this.water_sewer +
          this.electric +
          this.garbage_removal +
          this.landscaping_plowing +
          this.exterminator +
          this.business_license_renewal +
          this.accounting_payroll_services +
          this.hoa_fees +
          this.food +
          this.housekeeping_supplies +
          this.office_supplies +
          this.security_monitoring +
          this.recreational_activities +
          this.website_advertising +
          this.referral_fees_start_up +
          this.referral_fees_ongoing +
          this.insurance_liability +
          this.cable +
          this.repairs_maintenance +
          this.transportation +
          this.furniture_lease +
          this.membership_fees +
          otherGeneralSum +
          otherMiscSum;

        this.total_general_expenses_goi = data.data[0].total_general_year_goi;
        this.total_monthly_general_expenses = this.total_general_expenses / 12;
        this.total_monthly_general_expenses_goi = this.total_general_expenses_goi;

        // OPERATING EXPENSES ANNUAL AND MONTHLY TOTAL AND GOI
        this.total_operating_expenses = this.total_payroll + this.total_general_expenses;
        this.total_operating_expenses_goi = data.data[0].total_opex_year_goi;
        this.total_monthly_operating_expenses = this.total_operating_expenses / 12;
        this.total_monthly_operating_expenses_goi = this.total_operating_expenses_goi;

        // *******END BUYER'S PROJECTED TOTALS******//

        await this.monthlySellerValues();
        await this.payrollTotal();
        await this.generalTotal();
        await this.operatingTotal();
        await this.comparisonValue();
        await this.recastEmit.emit({ recastEmit: true });
      }
    });
  }

  // ###############PROJECTED OPERATING PAYROLL EXPENSES TOTALS################//
  payrollTotal() {
    // OTHER FIELDS CALCULATIONS
    let otherPayrollSum = 0;
    for (let i = 0; i < this.otherPayrollExpensesArray.length; i++) {
      otherPayrollSum += this.otherPayrollExpensesArray[i].seller_field_value;
    }

    // ##############SELLER'S PROJECTED TOTALS###############//
    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL ANNUAL PAYROLL EXPENSES
    this.recastPayrollTotalPayroll =
      +this.recastManagementFee +
      +this.recastManagerSalary +
      +this.recastManagerBonus +
      +this.recastCaregiversWages +
      +this.recastChef +
      +this.recastCleaningStaff +
      +otherPayrollSum;

    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL MONTHLY PAYROLL EXPENSES
    if (this.recastMonths === null || this.recastMonths === 0) {
      this.monthlyRecastPayrollTotalPayroll = 0;
    } else {
      this.monthlyRecastPayrollTotalPayroll = this.recastPayrollTotalPayroll / this.recastMonths;
    }

    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL ANNUAL PAYROLL EXPENSES GOI
    if (this.recastGOI === null || this.recastGOI === 0) {
      this.recastPayrollTotalGOI = 0;
    } else {
      this.recastPayrollTotalGOI = Math.round(
        (this.recastPayrollTotalPayroll / this.recastGOI) * 100
      );
    }

    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL MONTHLY PAYROLL EXPENSES GOI
    if (
      this.monthlyRecastPayrollTotalPayroll === null ||
      this.monthlyRecastPayrollTotalPayroll === 0 ||
      this.monthlyRecastGOI === null ||
      this.monthlyRecastGOI === 0
    ) {
      this.monthlyRecastPayrollTotalGOI = 0;
    } else {
      this.monthlyRecastPayrollTotalGOI = Math.round(
        (this.monthlyRecastPayrollTotalPayroll / this.monthlyRecastGOI) * 100
      );
    }
    // *******************END SELLER'S PROJECTED TOTALS*******************//

    // ############COMPARISON TOTALS OF ANNUAL AND MONTHLY GOI'S############//
    // COMPARISON PAYROLL EXPENSES  ANNUAL TOTAL

    // if(this.total_payroll !== 0 && this.monthlyRecastPayrollTotalPayroll === 0){
    //     this.comp_payroll = -100;
    // }else
    if (this.total_payroll === 0 || this.monthlyRecastPayrollTotalPayroll === 0) {
      this.comp_payroll = 0;
      this.comp_monthly_payroll = 0;
    } else {
      this.comp_payroll =
        (1 - this.total_payroll / (this.monthlyRecastPayrollTotalPayroll * 12)) * 100;
      // COMPARISON PAYROLL EXPENSES  MONTHLY TOTAL
      this.comp_monthly_payroll = Math.round(
        this.monthlyRecastPayrollTotalPayroll * 12 - this.total_payroll
      );
      // this.comp_monthly_payroll = Math.round(this.recastPayrollTotalPayroll - this.total_payroll);
    }

    // **************COMPARISON TOTALS OF ANNUAL AND MONTHLY GOI'S***************//
  }

  generalTotal() {
    // OTHER FIELDS CALCULATIONS
    let otherGeneralSum = 0;
    for (let i = 0; i < this.otherGeneralExpensesArray.length; i++) {
      otherGeneralSum += this.otherGeneralExpensesArray[i].seller_field_value;
    }
    let otherMiscSum = 0;
    for (let i = 0; i < this.otherOperExpensesArray.length; i++) {
      otherMiscSum += this.otherOperExpensesArray[i].seller_field_value;
    }

    // ##############SELLER'S PROJECTED TOTALS###############//
    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL ANNUAL GENERAL EXPENSES
    this.recastGeneralTotalPayroll =
      +this.recastRent +
      +this.recastTaxes +
      +this.recastInsuranceProperty +
      +this.recastGas +
      +this.recastWater +
      +this.recastElectric +
      +this.recastGarbageRemoval +
      +this.recastLandscaping +
      +this.recastExtermininator +
      +this.recastBusinessLicense +
      +this.recastAccountingServices +
      +this.recastHOFFees +
      +this.recastFood +
      +this.recastHousekeeping +
      +this.recastOfficeSupplies +
      +this.recastSecurityMonitoring +
      +this.recastRecreationalActivites +
      +this.recastWebsite +
      +this.recastReferralFeesStartup +
      +this.recastReferralFeesOngoing +
      +this.monthlyRecastInsuranceLiability +
      +this.recastCable +
      +this.recastRepairs +
      +this.recastTransportion +
      +this.recastFurnitureLease +
      +this.recastMembershipFees +
      +otherGeneralSum +
      +otherMiscSum;

    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL MONTHLY GENERAL EXPENSES
    if (this.recastMonths === null || this.recastMonths === 0) {
      this.monthlyRecastGeneralTotalPayroll = 0;
    } else {
      this.monthlyRecastGeneralTotalPayroll = this.recastGeneralTotalPayroll / this.recastMonths;
    }

    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL ANNUAL GENERAL EXPENSES GOI
    if (this.recastGOI === null || this.recastGOI === 0) {
      this.recastGeneralTotalGOI = 0;
    } else {
      this.recastGeneralTotalGOI = Math.round(
        (this.recastGeneralTotalPayroll / this.recastGOI) * 100
      );
    }
    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL MONTHLY GENERAL EXPENSES GOI
    if (
      this.monthlyRecastGeneralTotalPayroll === null ||
      this.monthlyRecastGeneralTotalPayroll === 0 ||
      this.monthlyRecastGOI === null ||
      this.monthlyRecastGOI === 0
    ) {
      this.monthlyRecastGeneralTotalGOI = 0;
    } else {
      this.monthlyRecastGeneralTotalGOI = Math.round(
        (this.monthlyRecastGeneralTotalPayroll / this.monthlyRecastGOI) * 100
      );
    }

    // *******************END SELLER'S PROJECTED TOTALS*******************//

    // ############COMPARISON TOTALS OF ANNUAL AND MONTHLY GOI'S############//
    // COMPARISON GENERAL EXPENSES  ANNUAL TOTAL

    // if(this.total_general_expenses !== 0 && this.monthlyRecastGeneralTotalPayroll === 0){
    //     this.comp_general_expenses = -100;
    // }else
    if (this.total_general_expenses === 0 || this.monthlyRecastGeneralTotalPayroll === 0) {
      this.comp_general_expenses = 0;
      this.comp_monthly_general_expenses = 0;
    } else {
      this.comp_general_expenses = this.comp_general_expenses =
        (1 - this.total_general_expenses / (this.monthlyRecastGeneralTotalPayroll * 12)) * 100;
      // COMPARISON GENERAL EXPENSES  MONTHLY TOTAL
      this.comp_monthly_general_expenses = Math.round(
        this.monthlyRecastGeneralTotalPayroll * 12 - this.total_general_expenses
      );
      // this.comp_monthly_general_expenses = Math.round(this.recastGeneralTotalPayroll - this.total_general_expenses);
    }
    // **************COMPARISON TOTALS OF ANNUAL AND MONTHLY GOI'S***************//
  }

  operatingTotal() {
    // ##############SELLER'S PROJECTED TOTALS###############//
    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL ANNUAL OPERATING EXPENSES
    this.recastOperatingPayroll = +this.recastPayrollTotalPayroll + +this.recastGeneralTotalPayroll;

    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL MONTHLY OPERATING EXPENSES
    if (this.recastMonths === null || this.recastMonths === 0) {
      this.monthlyRecastOperatingPayroll = 0;
    } else {
      this.monthlyRecastOperatingPayroll = this.recastOperatingPayroll / this.recastMonths;
    }
    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL ANNUAL OPERATING EXPENSES GOI
    if (this.recastGOI === null || this.recastGOI === 0) {
      this.recastOperatingGOI = 0;
    } else {
      this.recastOperatingGOI = Math.round((this.recastOperatingPayroll / this.recastGOI) * 100);
    }
    // SELLER'S PROJECTED OPERATING EXPENSES TOTAL MONTHLY OPERATING EXPENSES GOI
    if (this.monthlyRecastGOI === null || this.monthlyRecastGOI === 0) {
      this.monthlyRecastOperatingGOI = 0;
    } else {
      this.monthlyRecastOperatingGOI = Math.round(
        (this.monthlyRecastOperatingPayroll / this.monthlyRecastGOI) * 100
      );
    }

    // ************END OF SELLER'S PROJECTED OPERATING EXPENSES TOTALS***************//

    // ############COMPARISON TOTALS OF ANNUAL AND MONTHLY GOI'S############//
    // COMPARISON OPERATING EXPENSES  ANNUAL TOTAL
    // if(this.total_operating_expenses !== 0 && this.monthlyRecastOperatingPayroll === 0){
    //     this.comp_operating_expenses = -100;
    // }else
    if (this.total_operating_expenses === 0 || this.monthlyRecastOperatingPayroll === 0) {
      this.comp_operating_expenses = 0;
      this.comp_monthly_operating_expenses = 0;
    } else {
      this.comp_operating_expenses =
        (1 - this.total_operating_expenses / (this.monthlyRecastOperatingPayroll * 12)) * 100;
      // COMPARISON OPERATING EXPENSES MONTHLY TOTAL
      this.comp_monthly_operating_expenses = Math.round(
        this.monthlyRecastOperatingPayroll * 12 - this.total_operating_expenses
      );
      // this.comp_monthly_operating_expenses = Math.round(this.recastOperatingPayroll - this.total_operating_expenses);
    }
    // **************COMPARISON TOTALS OF ANNUAL AND MONTHLY GOI'S***************//
  }
  // **************END OF TOTALS OF ANNUAL AND MONTHLY GOI'S***************//

  comparisonValue() {
    // COMPARISON ANNUAL VALUES

    // if(this.monthlyRecastGOI === 0 && this.gross_operating_income !== 0){
    //     this.comp_gross_operating_income = -100;
    // }else
    if (this.monthlyRecastGOI === 0 || this.gross_operating_income === 0) {
      this.comp_gross_operating_income = 0;
      this.comp_monthly_gross_operating_income = 0;
    } else {
      // this.comp_gross_operating_income = ((1-this.gross_operating_income/(this.monthlyRecastGOI*12))*100);
      this.comp_gross_operating_income =
        (this.gross_operating_income / (this.monthlyRecastGOI * 12) - 1) * 100;
      this.comp_monthly_gross_operating_income = Math.round(
        this.gross_operating_income - this.monthlyRecastGOI * 12
      );
      // this.comp_monthly_gross_operating_income = Math.round((this.monthlyRecastGOI*12)-(this.gross_operating_income));
      // this.comp_monthly_gross_operating_income = Math.round(this.recastGOI-this.gross_operating_income);
    }

    // if(this.monthlyRecastManagementFee === 0 && this.management_fee !== 0){
    //     this.comp_management_fee = -100;
    // }else
    if (this.monthlyRecastManagementFee === 0 || this.management_fee === 0) {
      this.comp_management_fee = 0;
      this.comp_monthly_management_fee = 0;
    } else {
      this.comp_management_fee =
        (1 - this.management_fee / (this.monthlyRecastManagementFee * 12)) * 100;
      this.comp_monthly_management_fee = Math.round(
        this.monthlyRecastManagementFee * 12 - this.management_fee
      );
      // this.comp_monthly_management_fee = Math.round(this.recastManagementFee - this.management_fee);
    }

    // if(this.manager_salary !== 0 && this.monthlyRecastManagerSalary === 0){
    //     this.comp_manager_salary = -100;
    // }else
    if (this.manager_salary === 0 || this.monthlyRecastManagerSalary === 0) {
      this.comp_manager_salary = 0;
      this.comp_monthly_manager_salary = 0;
    } else {
      this.comp_manager_salary =
        (1 - this.manager_salary / (this.monthlyRecastManagerSalary * 12)) * 100;
      this.comp_monthly_manager_salary = Math.round(
        this.monthlyRecastManagerSalary * 12 - this.manager_salary
      );
      // this.comp_monthly_manager_salary = Math.round(this.recastManagerSalary - this.manager_salary);
    }

    // if(this.manager_bonus !== 0 || this.monthlyRecastManagerBonus === 0){
    //     this.comp_manager_bonus = -100;
    // }else
    if (this.manager_bonus === 0 || this.monthlyRecastManagerBonus === 0) {
      this.comp_manager_bonus = 0;
      this.comp_monthly_manager_bonus = 0;
    } else {
      this.comp_manager_bonus =
        (1 - this.manager_bonus / (this.monthlyRecastManagerBonus * 12)) * 100;
      this.comp_monthly_manager_bonus = Math.round(
        this.monthlyRecastManagerBonus * 12 - this.manager_bonus
      );
      // this.comp_monthly_manager_bonus = Math.round(this.recastManagerBonus - this.manager_bonus);
    }

    this.comp_workers_comp_factor = Math.round(this.workers_comp_factor - this.recastCompFactor);
    this.comp_monthly_workers_comp_factor = Math.round(
      this.recastCompFactor - this.workers_comp_factor
    );

    // if(this.caregivers_wages !== 0 && this.monthlyRecastCaregiversWages === 0){
    //     this.comp_caregivers_wages = -100;
    // }else
    if (this.caregivers_wages === 0 || this.monthlyRecastCaregiversWages === 0) {
      this.comp_caregivers_wages = 0;
      this.comp_monthly_caregivers_wages = 0;
    } else {
      this.comp_caregivers_wages =
        (1 - this.caregivers_wages / (this.monthlyRecastCaregiversWages * 12)) * 100;
      this.comp_monthly_caregivers_wages = Math.round(
        this.monthlyRecastCaregiversWages * 12 - this.caregivers_wages
      );
      // this.comp_monthly_caregivers_wages = Math.round(this.recastCaregiversWages - this.caregivers_wages);
    }

    // if(this.chef !== 0 && this.monthlyRecastChef === 0){
    //     this.comp_chef = -100;
    // }else
    if (this.chef === 0 || this.monthlyRecastChef === 0) {
      this.comp_chef = 0;
      this.comp_monthly_chef = 0;
    } else {
      this.comp_chef = (1 - this.chef / (this.monthlyRecastChef * 12)) * 100;
      this.comp_monthly_chef = Math.round(this.monthlyRecastChef * 12 - this.chef);
      // this.comp_monthly_chef = Math.round(this.recastChef - this.chef);
    }

    // if(this.cleaning_staff !== 0 && this.monthlyRecastCleaningStaff === 0){
    //     this.comp_cleaning_staff = -100;
    // }else
    if (this.cleaning_staff === 0 || this.monthlyRecastCleaningStaff === 0) {
      this.comp_cleaning_staff = 0;
      this.comp_monthly_cleaning_staff = 0;
    } else {
      this.comp_cleaning_staff =
        (1 - this.cleaning_staff / (this.monthlyRecastCleaningStaff * 12)) * 100;
      this.comp_monthly_cleaning_staff = Math.round(
        this.monthlyRecastCleaningStaff * 12 - this.cleaning_staff
      );
      // this.comp_monthly_cleaning_staff = Math.round(this.recastCleaningStaff - this.cleaning_staff);
    }

    // if(this.rent !== 0 && this.monthlyRecastRent === 0){
    //     this.comp_rent = -100;
    // }else
    if (this.rent === 0 || this.monthlyRecastRent === 0) {
      this.comp_rent = 0;
      this.comp_monthly_rent = 0;
    } else {
      this.comp_rent = (1 - this.rent / (this.monthlyRecastRent * 12)) * 100;
      this.comp_monthly_rent = Math.round(this.monthlyRecastRent * 12 - this.rent);
      // this.comp_monthly_rent = Math.round(this.recastRent - this.rent);
    }

    // if(this.taxes !== 0 && this.monthlyRecastTaxes === 0){
    //     this.comp_taxes = -100;
    // }else
    if (this.taxes === 0 || this.monthlyRecastTaxes === 0) {
      this.comp_taxes = 0;
      this.comp_monthly_taxes = 0;
    } else {
      this.comp_taxes = (1 - this.taxes / (this.monthlyRecastTaxes * 12)) * 100;
      this.comp_monthly_taxes = Math.round(this.monthlyRecastTaxes * 12 - this.taxes);
      // this.comp_monthly_taxes = Math.round(this.recastTaxes - this.taxes);
    }

    // if(this.insurance_property !== 0 && this.monthlyRecastInsuranceProperty === 0){
    //     this.comp_insurance_property = -100;
    // }else
    if (this.insurance_property === 0 || this.monthlyRecastInsuranceProperty === 0) {
      this.comp_insurance_property = 0;
      this.comp_monthly_insurance_property = 0;
    } else {
      this.comp_insurance_property =
        (1 - this.insurance_property / (this.monthlyRecastInsuranceProperty * 12)) * 100;
      this.comp_monthly_insurance_property = Math.round(
        this.monthlyRecastInsuranceProperty * 12 - this.insurance_property
      );
      // this.comp_monthly_insurance_property = Math.round(this.recastInsuranceProperty - this.insurance_property);
    }

    // if(this.gas !== 0 && this.monthlyRecastGas === 0){
    //     this.comp_gas = -100;
    // }else
    if (this.gas === 0 || this.monthlyRecastGas === 0) {
      this.comp_gas = 0;
      this.comp_monthly_gas = 0;
    } else {
      this.comp_gas = (1 - this.gas / (this.monthlyRecastGas * 12)) * 100;
      this.comp_monthly_gas = Math.round(this.monthlyRecastGas * 12 - this.gas);
      // this.comp_monthly_gas = Math.round(this.recastGas - this.gas);
    }

    // if(this.water_sewer !== 0 && this.monthlyRecastWater === 0){
    //     this.comp_water_sewer = -100;
    // }else
    if (this.water_sewer === 0 || this.monthlyRecastWater === 0) {
      this.comp_water_sewer = 0;
      this.comp_monthly_water_sewer = 0;
    } else {
      this.comp_water_sewer = (1 - this.water_sewer / (this.monthlyRecastWater * 12)) * 100;
      this.comp_monthly_water_sewer = Math.round(this.monthlyRecastWater * 12 - this.water_sewer);
      // this.comp_monthly_water_sewer = Math.round(this.recastWater - this.water_sewer);
    }

    // if(this.electric !== 0 && this.monthlyRecastElectric === 0){
    //     this.comp_electric = -100;
    // }else
    if (this.electric === 0 || this.monthlyRecastElectric === 0) {
      this.comp_electric = 0;
      this.comp_monthly_electric = 0;
    } else {
      this.comp_electric = (1 - this.electric / (this.monthlyRecastElectric * 12)) * 100;
      this.comp_monthly_electric = Math.round(this.monthlyRecastElectric * 12 - this.electric);
      // this.comp_monthly_electric = Math.round(this.recastElectric - this.electric);
    }

    // if(this.garbage_removal !== 0 && this.monthlyRecastGarbageRemoval === 0){
    //     this.comp_garbage_removal = -100;
    // }else
    if (this.garbage_removal === 0 || this.monthlyRecastGarbageRemoval === 0) {
      this.comp_garbage_removal = 0;
      this.comp_monthly_garbage_removal = 0;
    } else {
      this.comp_garbage_removal =
        (1 - this.garbage_removal / (this.monthlyRecastGarbageRemoval * 12)) * 100;
      this.comp_monthly_garbage_removal = Math.round(
        this.monthlyRecastGarbageRemoval * 12 - this.garbage_removal
      );
      // this.comp_monthly_garbage_removal= Math.round(this.recastGarbageRemoval - this.garbage_removal);
    }

    // if(this.landscaping_plowing !== 0 && this.monthlyRecastLandscaping === 0){
    //     this.comp_landscaping_plowing = -100;
    // }else
    if (this.landscaping_plowing === 0 || this.monthlyRecastLandscaping === 0) {
      this.comp_landscaping_plowing = 0;
      this.comp_monthly_landscaping_plowing = 0;
    } else {
      this.comp_landscaping_plowing =
        (1 - this.landscaping_plowing / (this.monthlyRecastLandscaping * 12)) * 100;
      this.comp_monthly_landscaping_plowing = Math.round(
        this.monthlyRecastLandscaping * 12 - this.landscaping_plowing
      );
      // this.comp_monthly_landscaping_plowing = Math.round(this.recastLandscaping - this.landscaping_plowing);
    }

    // if(this.exterminator !== 0 && this.monthlyRecastExtermininator === 0){
    //     this.comp_exterminator = -100;
    // }else
    if (this.exterminator === 0 || this.monthlyRecastExtermininator === 0) {
      this.comp_exterminator = 0;
      this.comp_monthly_exterminator = 0;
    } else {
      this.comp_exterminator =
        (1 - this.exterminator / (this.monthlyRecastExtermininator * 12)) * 100;
      this.comp_monthly_exterminator = Math.round(
        this.monthlyRecastExtermininator * 12 - this.exterminator
      );
      // this.comp_monthly_exterminator = Math.round(this.recastExtermininator - this.exterminator);
    }

    // if(this.business_license_renewal !== 0 && this.monthlyRecastBusinessLicense === 0){
    //     this.comp_business_license_renewal = -100;
    // }else
    if (this.business_license_renewal === 0 || this.monthlyRecastBusinessLicense === 0) {
      this.comp_business_license_renewal = 0;
      this.comp_monthly_business_license_renewal = 0;
    } else {
      this.comp_business_license_renewal =
        (1 - this.business_license_renewal / (this.monthlyRecastBusinessLicense * 12)) * 100;
      this.comp_monthly_business_license_renewal = Math.round(
        this.monthlyRecastBusinessLicense * 12 - this.business_license_renewal
      );
      // this.comp_monthly_business_license_renewal = Math.round(this.recastBusinessLicense - this.business_license_renewal);
    }

    // if(this.accounting_payroll_services !== 0 && this.monthlyRecastAccountingServices === 0){
    //     this.comp_accounting_payroll_services = -100;
    // }else
    if (this.accounting_payroll_services === 0 || this.monthlyRecastAccountingServices === 0) {
      this.comp_accounting_payroll_services = 0;
      this.comp_monthly_accounting_payroll_services = 0;
    } else {
      this.comp_accounting_payroll_services =
        (1 - this.accounting_payroll_services / (this.monthlyRecastAccountingServices * 12)) * 100;
      this.comp_monthly_accounting_payroll_services = Math.round(
        this.monthlyRecastAccountingServices * 12 - this.accounting_payroll_services
      );
      // this.comp_monthly_accounting_payroll_services = Math.round(this.recastAccountingServices - this.accounting_payroll_services);
    }

    // if(this.hoa_fees !== 0 && this.monthlyRecastHOFFees === 0){
    //     this.comp_hoa_fees = -100;
    // }else
    if (this.hoa_fees === 0 || this.monthlyRecastHOFFees === 0) {
      this.comp_hoa_fees = 0;
      this.comp_monthly_hoa_fees = 0;
    } else {
      this.comp_hoa_fees = (1 - this.hoa_fees / (this.monthlyRecastHOFFees * 12)) * 100;
      this.comp_monthly_hoa_fees = Math.round(this.monthlyRecastHOFFees * 12 - this.hoa_fees);
      // this.comp_monthly_hoa_fees = Math.round(this.recastHOFFees - this.hoa_fees);
    }

    // if(this.food !== 0 && this.monthlyRecastFood === 0){
    //     this.comp_food = -100;
    // }else
    if (this.food === 0 || this.monthlyRecastFood === 0) {
      this.comp_food = 0;
      this.comp_monthly_food = 0;
    } else {
      this.comp_food = (1 - this.food / (this.monthlyRecastFood * 12)) * 100;
      this.comp_monthly_food = Math.round(this.monthlyRecastFood * 12 - this.food);
      // this.comp_monthly_food = Math.round(this.recastFood - this.food);
    }

    // if(this.housekeeping_supplies !== 0 && this.monthlyRecastHousekeeping === 0){
    //     this.comp_housekeeping_supplies = -100;
    // }else
    if (this.housekeeping_supplies === 0 || this.monthlyRecastHousekeeping === 0) {
      this.comp_housekeeping_supplies = 0;
      this.comp_monthly_housekeeping_supplies = 0;
    } else {
      this.comp_housekeeping_supplies =
        (1 - this.housekeeping_supplies / (this.monthlyRecastHousekeeping * 12)) * 100;
      this.comp_monthly_housekeeping_supplies = Math.round(
        this.monthlyRecastHousekeeping * 12 - this.housekeeping_supplies
      );
      // this.comp_monthly_housekeeping_supplies = Math.round(this.recastHousekeeping - this.housekeeping_supplies)
    }

    // if(this.office_supplies !== 0 && this.monthlyRecastOfficeSupplies === 0){
    //     this.comp_office_supplies = -100;
    // }else
    if (this.office_supplies === 0 || this.monthlyRecastOfficeSupplies === 0) {
      this.comp_office_supplies = 0;
      this.comp_monthly_office_supplies = 0;
    } else {
      this.comp_office_supplies =
        (1 - this.office_supplies / (this.monthlyRecastOfficeSupplies * 12)) * 100;
      this.comp_monthly_office_supplies = Math.round(
        this.monthlyRecastOfficeSupplies * 12 - this.office_supplies
      );
      // this.comp_monthly_office_supplies = Math.round(this.recastOfficeSupplies - this.office_supplies);
    }

    // if(this.security_monitoring !== 0 && this.monthlyRecastSecurityMonitoring === 0){
    //     this.comp_security_monitoring = -100;
    // }else
    if (this.security_monitoring === 0 || this.monthlyRecastSecurityMonitoring === 0) {
      this.comp_security_monitoring = 0;
      this.comp_monthly_security_monitoring = 0;
    } else {
      this.comp_security_monitoring =
        (1 - this.security_monitoring / (this.monthlyRecastSecurityMonitoring * 12)) * 100;
      this.comp_monthly_security_monitoring = Math.round(
        this.monthlyRecastSecurityMonitoring * 12 - this.security_monitoring
      );
      // this.comp_monthly_security_monitoring = Math.round(this.recastSecurityMonitoring - this.security_monitoring);
    }

    // if(this.recreational_activities !== 0 && this.monthlyRecastRecreationalActivites === 0){
    //     this.comp_recreational_activities = -100;
    // }else
    if (this.recreational_activities === 0 || this.monthlyRecastRecreationalActivites === 0) {
      this.comp_recreational_activities = 0;
      this.comp_monthly_recreational_activities = 0;
    } else {
      this.comp_recreational_activities =
        (1 - this.recreational_activities / (this.monthlyRecastRecreationalActivites * 12)) * 100;
      this.comp_monthly_recreational_activities = Math.round(
        this.monthlyRecastRecreationalActivites * 12 - this.recreational_activities
      );
      // this.comp_monthly_recreational_activities = Math.round(this.recastRecreationalActivites - this.recreational_activities);
    }

    // if(this.website_advertising !== 0 && this.monthlyRecastWebsite === 0){
    //     this.comp_website_advertising = -100;
    // }else
    if (this.website_advertising === 0 || this.monthlyRecastWebsite === 0) {
      this.comp_website_advertising = 0;
      this.comp_monthly_website_advertising = 0;
    } else {
      this.comp_website_advertising =
        (1 - this.website_advertising / (this.monthlyRecastWebsite * 12)) * 100;
      this.comp_monthly_website_advertising = Math.round(
        this.monthlyRecastWebsite * 12 - this.website_advertising
      );
      // this.comp_monthly_website_advertising = Math.round(this.recastWebsite - this.website_advertising);
    }

    // if(this.referral_fees_start_up !== 0 && this.monthlyRecastReferralFeesStartup === 0){
    //     this.comp_referral_fees_start_up = -100;
    // }else
    if (this.referral_fees_start_up === 0 || this.monthlyRecastReferralFeesStartup === 0) {
      this.comp_referral_fees_start_up = 0;
      this.comp_monthly_referral_fees_start_up = 0;
    } else {
      this.comp_referral_fees_start_up =
        (1 - this.referral_fees_start_up / (this.monthlyRecastReferralFeesStartup * 12)) * 100;
      this.comp_monthly_referral_fees_start_up = Math.round(
        this.monthlyRecastReferralFeesStartup * 12 - this.referral_fees_start_up
      );
      // this.comp_monthly_referral_fees_start_up = Math.round(this.recastReferralFeesStartup - this.referral_fees_start_up);
    }

    // if(this.referral_fees_ongoing !== 0 && this.monthlyRecastReferralFeesOngoing === 0){
    //     this.comp_referral_fees_ongoing = -100;
    // }else
    if (this.referral_fees_ongoing === 0 || this.monthlyRecastReferralFeesOngoing === 0) {
      this.comp_referral_fees_ongoing = 0;
      this.comp_monthly_referral_fees_ongoing = 0;
    } else {
      this.comp_referral_fees_ongoing =
        (1 - this.referral_fees_ongoing / (this.monthlyRecastReferralFeesOngoing * 12)) * 100;
      this.comp_monthly_referral_fees_ongoing = Math.round(
        this.monthlyRecastReferralFeesOngoing * 12 - this.referral_fees_ongoing
      );
      // this.comp_monthly_referral_fees_ongoing = Math.round(this.recastReferralFeesOngoing - this.referral_fees_ongoing);
    }

    // if(this.insurance_liability !== 0 && this.monthlyRecastInsuranceLiability === 0){
    //     this.comp_insurance_liability = -100;
    // }else
    if (this.insurance_liability === 0 || this.monthlyRecastInsuranceLiability === 0) {
      this.comp_insurance_liability = 0;
      this.comp_monthly_insurance_liability = 0;
    } else {
      this.comp_insurance_liability =
        (1 - this.insurance_liability / (this.monthlyRecastInsuranceLiability * 12)) * 100;
      this.comp_monthly_insurance_liability = Math.round(
        this.monthlyRecastInsuranceLiability * 12 - this.insurance_liability
      );
      // this.comp_monthly_insurance_liability = Math.round(this.recastInsuranceLiability - this.insurance_liability);
    }

    // if(this.cable !== 0 && this.monthlyRecastCable === 0){
    //     this.comp_cable = -100;
    // }else
    if (this.cable === 0 || this.monthlyRecastCable === 0) {
      this.comp_cable = 0;
      this.comp_monthly_cable = 0;
    } else {
      this.comp_cable = (1 - this.cable / (this.monthlyRecastCable * 12)) * 100;
      this.comp_monthly_cable = Math.round(this.monthlyRecastCable * 12 - this.cable);
      // this.comp_monthly_cable = Math.round(this.recastCable - this.cable);
    }

    // if(this.repairs_maintenance !== 0 && this.monthlyRecastRepairs === 0){
    //     this.comp_repairs_maintenance = -100;
    // }else
    if (this.repairs_maintenance === 0 || this.monthlyRecastRepairs === 0) {
      this.comp_repairs_maintenance = 0;
      this.comp_monthly_repairs_maintenance = 0;
    } else {
      this.comp_repairs_maintenance =
        (1 - this.repairs_maintenance / (this.monthlyRecastRepairs * 12)) * 100;
      this.comp_monthly_repairs_maintenance = Math.round(
        this.monthlyRecastRepairs * 12 - this.repairs_maintenance
      );
    }

    // if(this.transportation !== 0 && this.monthlyRecastTransportion === 0){
    //     this.comp_transportation = -100;
    // }else
    if (this.transportation === 0 || this.monthlyRecastTransportion === 0) {
      this.comp_transportation = 0;
      this.comp_monthly_transportation = 0;
    } else {
      this.comp_transportation =
        (1 - this.transportation / (this.monthlyRecastTransportion * 12)) * 100;
      this.comp_monthly_transportation = Math.round(
        this.monthlyRecastTransportion * 12 - this.transportation
      );
      // this.comp_monthly_transportation = Math.round(this.recastTransportion - this.transportation);
    }

    // if(this.furniture_lease !== 0 && this.monthlyRecastFurnitureLease === 0){
    //     this.comp_furniture_lease = -100;
    // }else
    if (this.furniture_lease === 0 || this.monthlyRecastFurnitureLease === 0) {
      this.comp_furniture_lease = 0;
      this.comp_monthly_furniture_lease = 0;
    } else {
      this.comp_furniture_lease =
        (1 - this.furniture_lease / (this.monthlyRecastFurnitureLease * 12)) * 100;
      this.comp_monthly_furniture_lease = Math.round(
        this.monthlyRecastFurnitureLease * 12 - this.furniture_lease
      );
      // this.comp_monthly_furniture_lease = Math.round(this.recastFurnitureLease - this.furniture_lease);
    }

    // if(this.membership_fees !== 0 && this.monthlyRecastMembershipFees === 0){
    //     this.comp_membership_fees = -100;
    // }else
    if (this.membership_fees === 0 || this.monthlyRecastMembershipFees === 0) {
      this.comp_membership_fees = 0;
      this.comp_monthly_membership_fees = 0;
    } else {
      this.comp_membership_fees =
        (1 - this.membership_fees / (this.monthlyRecastMembershipFees * 12)) * 100;
      this.comp_monthly_membership_fees = Math.round(
        this.monthlyRecastMembershipFees * 12 - this.membership_fees
      );
      // this.comp_monthly_membership_fees = Math.round(this.recastMembershipFees - this.membership_fees);
    }

    // OTHER FIELDS CALCULATIONS FOR COMPARISON GOI & EXPENSES
    for (let i = 0; i < this.otherPayrollExpensesArray.length; i++) {
      // if(this.otherPayrollExpensesArray[i]['total_other_payroll'] !== 0 && this.otherPayrollExpensesArray[i]['monthly_values'] === 0){
      //     this.otherPayrollExpensesArray[i]['comparison_annual_values'] = -100;
      // }else
      if (
        this.otherPayrollExpensesArray[i].total_other_payroll === 0 ||
        this.otherPayrollExpensesArray[i].monthly_values === 0
      ) {
        this.otherPayrollExpensesArray[i].comparison_annual_values = 0;
        this.otherPayrollExpensesArray[i].comparison_monthly_values = 0;
      } else {
        this.otherPayrollExpensesArray[i].comparison_annual_values = Math.round(
          (1 -
            this.otherPayrollExpensesArray[i].total_other_payroll /
              (this.otherPayrollExpensesArray[i].monthly_values * 12)) *
            100
        );

        this.otherPayrollExpensesArray[i].comparison_monthly_values = Math.round(
          this.otherPayrollExpensesArray[i].monthly_values * 12 -
            this.otherPayrollExpensesArray[i].total_other_payroll
        );
        // this.otherPayrollExpensesArray[i]['comparison_monthly_values'] = Math.round(this.otherPayrollExpensesArray[i]['seller_field_value'] - this.otherPayrollExpensesArray[i]['total_other_payroll']);
      }
    }

    for (let i = 0; i < this.otherGeneralExpensesArray.length; i++) {
      // if(this.otherGeneralExpensesArray[i]['total_other_general'] !== 0 && this.otherGeneralExpensesArray[i]['monthly_values'] === 0){
      //     this.otherGeneralExpensesArray[i]['comparison_annual_values'] = -100;
      // }else
      if (
        this.otherGeneralExpensesArray[i].total_other_general === 0 ||
        this.otherGeneralExpensesArray[i].monthly_values === 0
      ) {
        this.otherGeneralExpensesArray[i].comparison_annual_values = 0;
        this.otherGeneralExpensesArray[i].comparison_monthly_values = 0;
      } else {
        this.otherGeneralExpensesArray[i].comparison_annual_values = Math.round(
          (1 -
            this.otherGeneralExpensesArray[i].total_other_general /
              (this.otherGeneralExpensesArray[i].monthly_values * 12)) *
            100
        );
        this.otherGeneralExpensesArray[i].comparison_monthly_values = Math.round(
          this.otherGeneralExpensesArray[i].monthly_values * 12 -
            this.otherGeneralExpensesArray[i].total_other_general
        );
        // this.otherGeneralExpensesArray[i]['comparison_monthly_values'] = Math.round(this.otherGeneralExpensesArray[i]['seller_field_value'] - this.otherGeneralExpensesArray[i]['total_other_general']);
      }
    }

    for (let i = 0; i < this.otherOperExpensesArray.length; i++) {
      // if(this.otherOperExpensesArray[i]['total_other_opex'] !== 0 && this.otherOperExpensesArray[i]['monthly_values'] === 0){
      //     this.otherOperExpensesArray[i]['comparison_annual_values'] = -100;
      // }else
      if (
        this.otherOperExpensesArray[i].total_other_opex === 0 ||
        this.otherOperExpensesArray[i].monthly_values === 0
      ) {
        this.otherOperExpensesArray[i].comparison_annual_values = 0;
        this.otherOperExpensesArray[i].comparison_monthly_values = 0;
      } else {
        this.otherOperExpensesArray[i].comparison_annual_values = Math.round(
          (1 -
            this.otherOperExpensesArray[i].total_other_opex /
              (this.otherOperExpensesArray[i].monthly_values * 12)) *
            100
        );
        this.otherOperExpensesArray[i].comparison_monthly_values = Math.round(
          this.otherOperExpensesArray[i].monthly_values * 12 -
            this.otherOperExpensesArray[i].total_other_opex
        );
        // this.otherOperExpensesArray[i]['comparison_monthly_values'] = Math.round(this.otherOperExpensesArray[i]['seller_field_value'] - this.otherOperExpensesArray[i]['total_other_opex']);
      }
    }
  }

  // CALCULATIONS FOR SELLER'S MONTHLY RECAST DATA
  monthlySellerValues() {
    // OTHER FIELDS CALCULATIONS FOR SELLER'S MONTHLY RECAST DATA
    for (let i = 0; i < this.otherPayrollExpensesArray.length; i++) {
      this.otherPayrollExpensesArray[i].monthly_values = Math.round(
        this.otherPayrollExpensesArray[i].seller_field_value / this.recastMonths
      );
    }

    for (let i = 0; i < this.otherGeneralExpensesArray.length; i++) {
      this.otherGeneralExpensesArray[i].monthly_values = Math.round(
        this.otherGeneralExpensesArray[i].seller_field_value / this.recastMonths
      );
    }

    for (let i = 0; i < this.otherOperExpensesArray.length; i++) {
      this.otherOperExpensesArray[i].monthly_values = Math.round(
        this.otherOperExpensesArray[i].seller_field_value / this.recastMonths
      );
    }

    this.monthlyRecastOccupiedBeds = Math.round(this.recastOccupiedBeds / this.recastMonths);

    this.monthlyRecastGOI = this.recastGOI / this.recastMonths;

    this.monthlyRecastManagementFee = this.recastManagementFee / this.recastMonths;

    this.monthlyRecastManagerSalary = this.recastManagerSalary / this.recastMonths;

    this.monthlyRecastManagerBonus = this.recastManagerBonus / this.recastMonths;

    this.monthlyRecastCompFactor = this.recastCompFactor;

    this.monthlyRecastCaregiversWages = this.recastCaregiversWages / this.recastMonths;

    this.monthlyRecastChef = this.recastChef / this.recastMonths;

    this.monthlyRecastCleaningStaff = this.recastCleaningStaff / this.recastMonths;

    this.monthlyRecastRent = this.recastRent / this.recastMonths;

    this.monthlyRecastTaxes = this.recastTaxes / this.recastMonths;

    this.monthlyRecastInsuranceProperty = this.recastInsuranceProperty / this.recastMonths;

    this.monthlyRecastGas = this.recastGas / this.recastMonths;

    this.monthlyRecastWater = this.recastWater / this.recastMonths;

    this.monthlyRecastElectric = this.recastElectric / this.recastMonths;

    this.monthlyRecastGarbageRemoval = this.recastGarbageRemoval / this.recastMonths;

    this.monthlyRecastLandscaping = this.recastLandscaping / this.recastMonths;

    this.monthlyRecastExtermininator = this.recastExtermininator / this.recastMonths;

    this.monthlyRecastBusinessLicense = this.recastBusinessLicense / this.recastMonths;

    this.monthlyRecastAccountingServices = this.recastAccountingServices / this.recastMonths;

    this.monthlyRecastHOFFees = this.recastHOFFees / this.recastMonths;

    this.monthlyRecastFood = this.recastFood / this.recastMonths;

    this.monthlyRecastHousekeeping = this.recastHousekeeping / this.recastMonths;

    this.monthlyRecastOfficeSupplies = this.recastOfficeSupplies / this.recastMonths;

    this.monthlyRecastSecurityMonitoring = this.recastSecurityMonitoring / this.recastMonths;

    this.monthlyRecastRecreationalActivites = this.recastRecreationalActivites / this.recastMonths;

    this.monthlyRecastWebsite = this.recastWebsite / this.recastMonths;

    this.monthlyRecastReferralFeesStartup = this.recastReferralFeesStartup / this.recastMonths;

    this.monthlyRecastReferralFeesOngoing = this.recastReferralFeesOngoing / this.recastMonths;

    this.monthlyRecastInsuranceLiability = this.recastInsuranceLiability / this.recastMonths;

    this.monthlyRecastCable = this.recastCable / this.recastMonths;

    this.monthlyRecastRepairs = this.recastRepairs / this.recastMonths;

    this.monthlyRecastTransportion = this.recastTransportion / this.recastMonths;

    this.monthlyRecastFurnitureLease = this.recastFurnitureLease / this.recastMonths;

    this.monthlyRecastMembershipFees = this.recastMembershipFees / this.recastMonths;

    // CONDITION IF RECAST MONTHS ARE 0 THEN ALL OTHER MONTHLY FIELDS SHOULD BE 0
    if (this.recastMonths === null || this.recastMonths === 0) {
      this.monthlyRecastCleaningStaff = 0;
      this.monthlyRecastChef = 0;
      this.monthlyRecastCaregiversWages = 0;
      // this.monthlyRecastCompFactor = 0;
      this.monthlyRecastManagerBonus = 0;
      this.monthlyRecastManagerSalary = 0;
      this.monthlyRecastManagementFee = 0;
      this.monthlyRecastGOI = 0;
      this.monthlyRecastOccupiedBeds = 0;
      this.monthlyRecastRent = 0;
      this.monthlyRecastTaxes = 0;
      this.monthlyRecastInsuranceProperty = 0;
      this.monthlyRecastGas = 0;
      this.monthlyRecastWater = 0;
      this.monthlyRecastElectric = 0;
      this.monthlyRecastGarbageRemoval = 0;
      this.monthlyRecastLandscaping = 0;
      this.monthlyRecastExtermininator = 0;
      this.monthlyRecastBusinessLicense = 0;
      this.monthlyRecastAccountingServices = 0;
      this.monthlyRecastHOFFees = 0;
      this.monthlyRecastFood = 0;
      this.monthlyRecastHousekeeping = 0;
      this.monthlyRecastOfficeSupplies = 0;
      this.monthlyRecastSecurityMonitoring = 0;
      this.monthlyRecastRecreationalActivites = 0;
      this.monthlyRecastWebsite = 0;
      this.monthlyRecastReferralFeesStartup = 0;
      this.monthlyRecastReferralFeesOngoing = 0;
      this.monthlyRecastInsuranceLiability = 0;
      this.monthlyRecastCable = 0;
      this.monthlyRecastRepairs = 0;
      this.monthlyRecastTransportion = 0;
      this.monthlyRecastFurnitureLease = 0;
      this.monthlyRecastMembershipFees = 0;
      for (let i = 0; i < this.otherPayrollExpensesArray.length; i++) {
        this.otherPayrollExpensesArray[i].monthly_values = 0;
      }

      for (let i = 0; i < this.otherGeneralExpensesArray.length; i++) {
        this.otherGeneralExpensesArray[i].monthly_values = 0;
      }

      for (let i = 0; i < this.otherOperExpensesArray.length; i++) {
        this.otherOperExpensesArray[i].monthly_values = 0;
      }
    }
  }

  // TO UPDATE SELLERS RECAST DATA ONCHANGE OF FIELDS AND SAVE INTO DB AND PERFOME CALCULATIONS AS WELL
  updateValues(event) {
    const { id } = this;
    let value = this.replaceDollarsCommasPercentages(event.target.value);
    if (value === null || value === '') {
      value = 0;
    }
    const data = { fieldName: event.target.name, value };

    if (event.target.name === 'recastMonths') {
      if (value === this.recastMonthsInt) {
        return;
      }
      this.recastMonths = value;
      this.recastMonthsInt = value;
      this.monthlySellerValues();
    } else if (event.target.name === 'recastOccupiedBeds') {
      this.monthlyRecastOccupiedBeds = value / this.recastMonths;
    } else if (event.target.name === 'recastGOI') {
      this.recastGOI = value;
      if (value === this.recastGOIInt) {
        return;
      }
      this.monthlyRecastGOI = value / this.recastMonths;
    } else if (event.target.name === 'recastManagementFee') {
      this.recastManagementFee = value;
      if (value === this.recastManagementFeeInt) {
        return;
      }
      this.monthlyRecastManagementFee = value / this.recastMonths;
    } else if (event.target.name === 'recastManagerSalary') {
      this.recastManagerSalary = value;
      if (value === this.recastManagerSalaryInt) {
        return;
      }
      this.monthlyRecastManagerSalary = value / this.recastMonths;
    } else if (event.target.name === 'recastManagerBonus') {
      this.recastManagerBonus = value;
      if (value === this.recastManagerBonusInt) {
        return;
      }
      this.monthlyRecastManagerBonus = value / this.recastMonths;
    } else if (event.target.name === 'recastCompFactor') {
      this.recastCompFactor = value;
      if (value === this.recastCompFactorInt) {
        return;
      }
      this.monthlyRecastCompFactor = value;
    } else if (event.target.name === 'recastCaregiversWages') {
      this.recastCaregiversWages = value;
      if (value === this.recastCaregiversWagesInt) {
        return;
      }
      this.monthlyRecastCaregiversWages = value / this.recastMonths;
    } else if (event.target.name === 'recastChef') {
      this.recastChef = value;
      if (value === this.recastChefInt) {
        return;
      }
      this.monthlyRecastChef = value / this.recastMonths;
    } else if (event.target.name === 'recastCleaningStaff') {
      this.recastCleaningStaff = value;
      if (value === this.recastCleaningStaffInt) {
        return;
      }
      this.monthlyRecastCleaningStaff = value / this.recastMonths;
    } else if (event.target.name === 'recastRent') {
      this.recastRent = value;
      if (value === this.recastRentInt) {
        return;
      }
      this.monthlyRecastRent = value / this.recastMonths;
    } else if (event.target.name === 'recastTaxes') {
      this.recastTaxes = value;
      if (value === this.recastTaxesInt) {
        return;
      }
      this.monthlyRecastTaxes = value / this.recastMonths;
    } else if (event.target.name === 'recastInsuranceProperty') {
      this.recastInsuranceProperty = value;
      if (value === this.recastInsurancePropertyInt) {
        return;
      }
      this.monthlyRecastInsuranceProperty = value / this.recastMonths;
    } else if (event.target.name === 'recastGas') {
      this.recastGas = value;
      if (value === this.recastGasInt) {
        return;
      }
      this.monthlyRecastGas = value / this.recastMonths;
    } else if (event.target.name === 'recastWater') {
      this.recastWater = value;
      if (value === this.recastWaterInt) {
        return;
      }
      this.monthlyRecastWater = value / this.recastMonths;
    } else if (event.target.name === 'recastElectric') {
      this.recastElectric = value;
      if (value === this.recastElectricInt) {
        return;
      }
      this.monthlyRecastElectric = value / this.recastMonths;
    } else if (event.target.name === 'recastGarbageRemoval') {
      this.recastGarbageRemoval = value;
      if (value === this.recastGarbageRemovalInt) {
        return;
      }
      this.monthlyRecastGarbageRemoval = value / this.recastMonths;
    } else if (event.target.name === 'recastLandscaping') {
      this.recastLandscaping = value;
      if (value === this.recastLandscapingInt) {
        return;
      }
      this.monthlyRecastLandscaping = value / this.recastMonths;
    } else if (event.target.name === 'recastExtermininator') {
      this.recastExtermininator = value;
      if (value === this.recastExtermininatorInt) {
        return;
      }
      this.monthlyRecastExtermininator = value / this.recastMonths;
    } else if (event.target.name === 'recastBusinessLicense') {
      this.recastBusinessLicense = value;
      if (value === this.recastBusinessLicenseInt) {
        return;
      }
      this.monthlyRecastBusinessLicense = value / this.recastMonths;
    } else if (event.target.name === 'recastAccountingServices') {
      this.recastAccountingServices = value;
      if (value === this.recastAccountingServicesInt) {
        return;
      }
      this.monthlyRecastAccountingServices = value / this.recastMonths;
    } else if (event.target.name === 'recastHOFFees') {
      this.recastHOFFees = value;
      if (value === this.recastHOFFeesInt) {
        return;
      }
      this.monthlyRecastHOFFees = value / this.recastMonths;
    } else if (event.target.name === 'recastFood') {
      this.recastFood = value;
      if (value === this.recastFoodInt) {
        return;
      }
      this.monthlyRecastFood = value / this.recastMonths;
    } else if (event.target.name === 'recastHousekeeping') {
      this.recastHousekeeping = value;
      if (value === this.recastHousekeepingInt) {
        return;
      }
      this.monthlyRecastHousekeeping = value / this.recastMonths;
    } else if (event.target.name === 'recastOfficeSupplies') {
      this.recastOfficeSupplies = value;
      if (value === this.recastOfficeSuppliesInt) {
        return;
      }
      this.monthlyRecastOfficeSupplies = value / this.recastMonths;
    } else if (event.target.name === 'recastSecurityMonitoring') {
      this.recastSecurityMonitoring = value;
      if (value === this.recastSecurityMonitoringInt) {
        return;
      }
      this.monthlyRecastSecurityMonitoring = value / this.recastMonths;
    } else if (event.target.name === 'recastRecreationalActivites') {
      this.recastRecreationalActivites = value;
      if (value === this.recastRecreationalActivitesInt) {
        return;
      }
      this.monthlyRecastRecreationalActivites = value / this.recastMonths;
    } else if (event.target.name === 'recastWebsite') {
      this.recastWebsite = value;
      if (value === this.recastWebsiteInt) {
        return;
      }
      this.monthlyRecastWebsite = value / this.recastMonths;
    } else if (event.target.name === 'recastReferralFeesStartup') {
      this.recastReferralFeesStartup = value;
      if (value === this.recastReferralFeesStartupInt) {
        return;
      }
      this.monthlyRecastReferralFeesStartup = value / this.recastMonths;
    } else if (event.target.name === 'recastReferralFeesOngoing') {
      this.recastReferralFeesOngoing = value;
      if (value === this.recastReferralFeesOngoingInt) {
        return;
      }
      this.monthlyRecastReferralFeesOngoing = value / this.recastMonths;
    } else if (event.target.name === 'recastInsuranceLiability') {
      this.recastInsuranceLiability = value;
      if (value === this.recastInsuranceLiabilityInt) {
        return;
      }
      this.monthlyRecastInsuranceLiability = value / this.recastMonths;
    } else if (event.target.name === 'recastCable') {
      this.recastCable = value;
      if (value === this.recastCableInt) {
        return;
      }
      this.monthlyRecastCable = value / this.recastMonths;
    } else if (event.target.name === 'recastRepairs') {
      this.recastRepairs = value;
      if (value === this.recastRepairsInt) {
        return;
      }
      this.monthlyRecastRepairs = value / this.recastMonths;
    } else if (event.target.name === 'recastTransportion') {
      this.recastTransportion = value;
      if (value === this.recastTransportionInt) {
        return;
      }
      this.monthlyRecastTransportion = value / this.recastMonths;
    } else if (event.target.name === 'recastFurnitureLease') {
      this.recastFurnitureLease = value;
      if (value === this.recastFurnitureLeaseInt) {
        return;
      }
      this.monthlyRecastFurnitureLease = value / this.recastMonths;
    } else if (event.target.name === 'recastMembershipFees') {
      this.recastMembershipFees = value;
      if (value === this.recastMembershipFeesInt) {
        return;
      }
      this.monthlyRecastMembershipFees = value / this.recastMonths;
    }

    // CONDITION IF RECAST MONTHS ARE 0 THEN ALL OTHER MONTHLY FIELDS SHOULD BE 0
    if (this.recastMonths === null || this.recastMonths === 0) {
      this.monthlyRecastCleaningStaff = 0;
      this.monthlyRecastChef = 0;
      this.monthlyRecastCaregiversWages = 0;
      // this.monthlyRecastCompFactor = 0;
      this.monthlyRecastManagerBonus = 0;
      this.monthlyRecastManagerSalary = 0;
      this.monthlyRecastManagementFee = 0;
      this.monthlyRecastGOI = 0;
      this.monthlyRecastOccupiedBeds = 0;
      this.monthlyRecastRent = 0;
      this.monthlyRecastTaxes = 0;
      this.monthlyRecastInsuranceProperty = 0;
      this.monthlyRecastGas = 0;
      this.monthlyRecastWater = 0;
      this.monthlyRecastElectric = 0;
      this.monthlyRecastGarbageRemoval = 0;
      this.monthlyRecastLandscaping = 0;
      this.monthlyRecastExtermininator = 0;
      this.monthlyRecastBusinessLicense = 0;
      this.monthlyRecastAccountingServices = 0;
      this.monthlyRecastHOFFees = 0;
      this.monthlyRecastFood = 0;
      this.monthlyRecastHousekeeping = 0;
      this.monthlyRecastOfficeSupplies = 0;
      this.monthlyRecastSecurityMonitoring = 0;
      this.monthlyRecastRecreationalActivites = 0;
      this.monthlyRecastWebsite = 0;
      this.monthlyRecastReferralFeesStartup = 0;
      this.monthlyRecastReferralFeesOngoing = 0;
      this.monthlyRecastInsuranceLiability = 0;
      this.monthlyRecastCable = 0;
      this.monthlyRecastRepairs = 0;
      this.monthlyRecastTransportion = 0;
      this.monthlyRecastFurnitureLease = 0;
      this.monthlyRecastMembershipFees = 0;
      for (let i = 0; i < this.otherPayrollExpensesArray.length; i++) {
        this.otherPayrollExpensesArray[i].monthly_values = 0;
      }

      for (let i = 0; i < this.otherGeneralExpensesArray.length; i++) {
        this.otherGeneralExpensesArray[i].monthly_values = 0;
      }

      for (let i = 0; i < this.otherOperExpensesArray.length; i++) {
        this.otherOperExpensesArray[i].monthly_values = 0;
      }
    }

    this.operatingService.updateSeller(id, data).subscribe(async () => {
      // await this.monthlySellerValues();
      await this.payrollTotal();
      await this.generalTotal();
      await this.operatingTotal();
      await this.comparisonValue();
    });
  }

  // CLEAR ARRAY OF OTHERFIELDS SO THAT THEY CAN BE RE-INITIALIZED TO SAVE NEW ENTRIES
  clearData() {
    this.otherPayrollExpensesArray = [];
    this.otherGeneralExpensesArray = [];
    this.otherOperExpensesArray = [];
  }

  // GET SAVED OTHER FIELDS OF SELLERS AND BUYERS FROM DB
  getOtherFields(): Promise<Boolean> {
    return new Promise(() => {
      this.otherService.getOtherFields(this.projectId, 'operatingexpenses').subscribe((res) => {
        this.clearData();
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].child === 'payroll_expenses') {
            this.otherPayrollExpensesArray.push(res.data[i]);
          } else if (res.data[i].child === 'general_expenses') {
            this.otherGeneralExpensesArray.push(res.data[i]);
          } else if (res.data[i].child === 'misc_expenses') {
            this.otherOperExpensesArray.push(res.data[i]);
          }
        }
        this.otherEmitRecast.emit({ otherEmitRecast: true });
      });
    });
  }

  // UPDATE VALUES OF SELLER'S RECAST OTHERFIELDS INTO DB ONCHANGE OF FIELDS
  updateFieldNameValue(id, event) {
    const variableName = 'seller_field_value';
    let value = this.replaceDollarsCommasPercentages(event.target.value);
    if (value === null || value === '') {
      value = 0;
    }

    this.otherService.updateFieldNameValue(id, value, variableName).subscribe(async () => {
      // this.clearData();
      // this.getOtherFields();
      await this.monthlySellerValues();
      await this.payrollTotal();
      await this.generalTotal();
      await this.operatingTotal();
      await this.comparisonValue();
    });
  }

  // REMOVE , $ % . FROM THE INPUT ENTERED BY USER
  replaceDollarsCommasPercentages(value) {
    return value.replace(/[, $ %]+/g, '').trim();
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/recast/recast.component.ts